<script setup lang="ts">
type Props = {
  required?: boolean;
  error?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  required: false,
  error: false,
});
</script>

<template>
  <label
    class="text-md block text-left font-bold"
    :class="{ 'text-link-red': props.error, 'text-gray-700': !props.error }"
  >
    <slot />
    <span v-if="props.required" class="text-red-800"> *</span>
  </label>
</template>
